import { createRouter, createWebHistory } from 'vue-router';
import LoginView from '@/components/organisms/LoginView.vue';
import HomePage from '@/components/organisms/HomePage.vue';
import Trash from '../components/Trash.vue';
import BasicPage from '../components/BasicPage.vue';
import Sidebar from '@/components/Sidebar.vue';
import CardEdit from '@/components/organisms/CardEdit.vue';
import PropertyEdit from '@/components/organisms/PropertyEdit.vue';
import CardSideBar from '@/components/organisms/CardSideBar.vue';
import SkillSheet from '@/components/organisms/SkillSheet.vue';
import GuestSkillSheet from '@/components/organisms/GuestSkillSheet.vue';
import App from '@/App.vue'

const routes = [
  {
    path: '/',
    name: 'App',
    component: App,
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginView,
  },
  {
    path: '/home',
    name: 'Home',
    component: HomePage,
  },
  {
    path: '/cardEdit',
    name: 'cardEdit',
    component: CardEdit,
  },
  {
    path: '/property',
    name: 'propertyEdit',
    component: PropertyEdit,
  },
  {
    path: '/cardSide',
    name: 'cardSideBar',
    component: CardSideBar,
  },
  {
    path: '/sidebar',
    name: 'Sidebar',
    component: Sidebar
  },

  {
    path: '/trash',
    name: 'Trash',
    component: Trash
  },
  {
    path: '/skillSheet',
    name: 'SkillSheet',
    component: SkillSheet
  },
  {
    path: '/:id',
    name: 'BasicPage',
    component: BasicPage,
    props: true
  },
  {
    path: '/guestSkillSheet/:staffNum',
    name: 'guestSkillSheet',
    component: GuestSkillSheet,
    props: true,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

console.log("全てのルート：",router.getRoutes());

console.log("現在のルート：",router.currentRoute.value.path);


export default router;
